module.exports = __webpack_public_path__ + "static/media/Minion3-Semibold.2a8a8720.svg";